import styled from 'styled-components';
import Media from '../../assets/styles/media';

const StyledCustomerLogo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  height: 80px;
  min-height: 80px;

  ${Media.Below.tablet`
    height: 50px;
    min-height: 50px;
  `};

  ${Media.Below.mobileLarge`
    order: 1;
    flex: 1 1 50%;
    height: 45px;
    margin-bottom: 0;
    min-height: 0px;
  `};

  > img {
    height: 100%;
    width: auto;

    ${Media.Below.mobileLarge`
      width: auto;
    `}
  }
`;

export default StyledCustomerLogo;
